import React from "react";
import { connect } from "react-redux";
import {
  hmgGet,
  hmgHotels,
  hmgmainGetHmgMain,
  projectGetHotels,
} from "../../store/actions";
import HmgDropdown from "./HmgDropdown";
import HotelDropdown from "./HotelDropdown";
import HmgMainDropdown from "./HmgMainDropdown";
import SelectAll from "./SelectAll";
import { getHmgProjectLists, getHmgs } from "../../api/hmg";


const hmgStyles = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 8 },
    lg: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 12 },
    lg: { span: 10 },
  },
};

const hmgStylesWithoutMargin = {
  ...hmgStyles,
  style: { marginBottom: 0 },
};

class HotelDropdownComponent extends React.Component {
  constructor() {
    super();
    this.state = {
      hmgmainList: [],
      hotelList: [],
      projectList: [],
    };
  }

  async componentDidMount() {
    const result = [];
    const hmgList = await getHmgs();
    result.push(...hmgList);
    this.setState({
      hmgmainList: result,
    });
  }

  loadHotelList = async (e) => {
    // await this.props.hmgHotelGet(e);
    let hotelList = [];
    const apiresponse = await this.props.projectGetHotels(e);
    hotelList = apiresponse.map((elem) => {
      return {
        id: elem._id,
        name: elem.hotel_name,
        hotel_code: elem.hotel_code,
      };
    });
    this.setState(
      {
        hotelList: hotelList,
      },
      () => {
        if (this.props.afterHotelLoad !== undefined) {
          this.props.afterHotelLoad();
        }
      }
    );
  };

  handleSelectChange = (e) => {
    this.props.setAllHotels(e.target.checked);
    if (e.target.checked && Array.isArray(this.state.hotelList)) {
      const hotels = this.state.hotelList;
      this.props.handleHotelChange(
        hotels.map(function (value) {
          return value.id;
        })
      );
    } else if (!e.target.checked) {
      this.props.handleHotelChange([]);
    }
    // this.setState({allHotels:e.target.checked},()=>{
    //     if (e.target.checked && this.props.api.hmgGetData!==null) {
    //         const hotels = this.state.hotelList;
    //         this.props.handleHotelChange(hotels.map(function (value) {
    //           return value.id;
    //         }));
    //     }
    // })
  };

  hotelChange = (e) => {
    this.props.handleHotelChange(e);
    if (
      this.props.multipleHotels !== undefined &&
      this.props.multipleHotels &&
      e.length != this.state.hotelList.length
    ) {
      // this.setState({allHotels:false});
      if (this.props.setAllHotels !== undefined) {
        this.props.setAllHotels(false);
      }
    }
  };

  hmgChange = (params) => {
    this.props.handleHmgChange(params);
    // this.setState({
    //     allHotels:false
    // })
    if (this.props.setAllHotels !== undefined) {
      this.props.setAllHotels(false);
    }
  };

  hmgmainChange = async (e) => {
    this.props.hmgmainChange(e);
    const projects = await getHmgProjectLists(e);
    if (projects) {
      this.setState({
        projectList: projects,
      });
    }
  };

  render() {
    return (
      <div>
        <HmgMainDropdown
          hmgmainSelect={this.props.hmgmainSelect}
          hmgmainList={this.state.hmgmainList}
          hmgmainChange={this.hmgmainChange}
        />
        <HmgDropdown
          hmgStyles={hmgStylesWithoutMargin}
          hmgSelect={this.props.hmgSelect}
          handleHmgChange={this.hmgChange}
          loadHotelList={this.loadHotelList}
          projectList={this.state.projectList}
          removeReportSelect={
            this.props.removeReportSelect !== undefined &&
            this.props.removeReportSelect
              ? true
              : false
          }
        />
        {this.props.multipleHotels !== undefined &&
        this.props.multipleHotels &&
        this.props.hmgSelect !== undefined ? (
          <SelectAll
            allHotels={this.props.allhotelSelect}
            multiple={
              this.props.multipleHotels !== undefined &&
              this.props.multipleHotels
                ? true
                : false
            }
            handleSelectChange={this.handleSelectChange}
          />
        ) : null}
        <HotelDropdown
          hotelList={this.state.hotelList}
          handleHotelChange={this.hotelChange}
          hotelSelect={this.props.hotelSelect}
          multiple={
            this.props.multipleHotels !== undefined && this.props.multipleHotels
              ? true
              : false
          }
          allowClear={
            this.props.allowClear !== undefined ? this.props.allowClear : false
          }
          label={
            typeof this.props.hotellabel === "string"
              ? this.props.hotellabel
              : "Hotel Name"
          }
          hotelTooltip={this.props.hotelTooltip}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    hmgGet: () => dispatch(hmgGet()),
    hmgHotelGet: (id) => dispatch(hmgHotels(id)),
    hmgmainGetHmgMain: () => dispatch(hmgmainGetHmgMain()),
    projectGetHotels: (id) => dispatch(projectGetHotels(id)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HotelDropdownComponent);
